import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

import { NodeFieldsDataService } from '../../services/data.service';

@Component({
  selector: 'app-edit-dialog',
  templateUrl: './edit-dialog.component.html',
  styleUrls: ['./edit-dialog.component.css'],
  standalone: false,
})
export class NodeFieldEditDialogComponent {
  public formControl = new FormControl('', [Validators.required]);

  public field;
  // public fieldLabel;
  private catchIndex;

  constructor(
    public dialogRef: MatDialogRef<NodeFieldEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public editData: any,
    private dataService: NodeFieldsDataService,
  ) {
    const newDataRow = {};
    this.field = editData['data']['field'];
    // this.fieldLabel = editData['data']['fieldLabel'];
    this.catchIndex = editData['data']['catchindex'];
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmAdd(): void {
    const newTableColumnDataRow: { [key: string]: {} } = {};
    newTableColumnDataRow['field'] = this.field;
    // newTableColumnDataRow['fieldLabel'] = this.fieldLabel;

    this.dataService.updateRecord(newTableColumnDataRow);
  }
}
